import { effect, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DarkModeService {

  darkModeSignal = signal<string>(
    JSON.parse(window.localStorage.getItem('darkModeSignal') ?? 'null')
  );

  constructor() {
    effect(() => {
      window.localStorage.setItem('darkModeSignal', JSON.stringify(this.darkModeSignal()));
    })
  }

  updateDarkMode() {
    this.darkModeSignal.update((value) => {
      const newVal = value === "dark" ? "null" : 'dark';
      if (newVal === 'dark') {
        // document.getElementById('html').setAttribute('data-bs-theme', 'true');
        document.documentElement.setAttribute("data-bs-theme", "true");
        document.documentElement.className = 'bg-dark-skin-primary';

      } else {
        document.documentElement.removeAttribute("data-bs-theme");
        document.documentElement.className = '';
        // document.getElementById('html').removeAttribute('data-bs-theme');
      }

      return newVal;
    })
  }

  isDarkModeOn(): boolean {
    return this.darkModeSignal() === 'dark';
  }

  turnOffDarkModeIfOn(): boolean {
    if (this.isDarkModeOn()) {
      this.updateDarkMode();
      return true;
    }
    return false;
  }
}
